export default function LoadingSplash() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#1976d2",
        color: "white",
        gap: "12px",
      }}
    >
      <img
        src="/icons/icon-192.png"
        alt="Canvass"
        style={{ width: 96, height: 96 }}
      />
      <div style={{ fontSize: 20, fontWeight: 600, letterSpacing: 0.5 }}>
        Canvass
      </div>
    </div>
  );
}
